import { render, staticRenderFns } from "./InstitutionalProjectReview.vue?vue&type=template&id=5544765e&scoped=true"
import script from "./InstitutionalProjectReview.vue?vue&type=script&lang=js"
export * from "./InstitutionalProjectReview.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalProjectReview.vue?vue&type=style&index=0&id=5544765e&prod&scoped=true&lang=css"
import style1 from "./InstitutionalProjectReview.vue?vue&type=style&index=1&id=5544765e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5544765e",
  null
  
)

export default component.exports